import { LGraphNode, LiteGraph } from "litegraph.js";

export class ImageRenderNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Image Render";

    this.properties = {
      canvasWidth: 1500,
      canvasHeight: 1500,
      imageSize: parseInt(this.getUrlParam("imageSize")) || 1500,
      imageSrc: this.getUrlParam("imageSrc") || null
    };

    this.canvas = document.createElement("canvas");
    this.ctx = this.canvas.getContext("2d");

    this.addInput("TextCanvas", "canvas");
    this.addOutput("Canvas", "canvas");

    this.addWidget("button", "Upload Image", null, () => this.uploadImage());
    this.addWidget("slider", "Image Size", this.properties.imageSize, (val) => {
      this.properties.imageSize = Math.round(val);
      this.updateUrlParam("imageSize", Math.round(val));
    }, { min: 50, max: 3000 });

    this.image = new Image();
    this.image.onload = () => this.setDirtyCanvas(true);

    if (this.properties.imageSrc) {
      this.image.src = this.properties.imageSrc;
    }

    this.size = [200, 95];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  uploadImage() {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = (event) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.properties.imageSrc = e.target.result;
          this.image.src = this.properties.imageSrc;
        };
        reader.readAsDataURL(file);
      }
    };
    input.click();
  }

  getUrlParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  updateUrlParam() {}

  onExecute() {
    this.canvas.width = this.properties.canvasWidth;
    this.canvas.height = this.properties.canvasHeight;
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    if (this.image.src && this.image.complete) {
      const size = this.properties.imageSize;
      const width = size;
      const height = this.image.height / this.image.width * size;
      const x = (this.canvas.width - width) / 2;
      const y = (this.canvas.height - height) / 2;
      this.ctx.drawImage(this.image, x, y, width, height);
    }

    const textCanvas = this.getInputData(0);
    if (textCanvas) {
      this.ctx.drawImage(textCanvas, 0, 0);
    }

    this.setOutputData(0, this.canvas);
  }
}
